import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RouteService } from './route.service';

let AppContext = {
  fastForward: environment.courses.fastForward
};

export type AppContext = typeof AppContext;

@Injectable({
  providedIn: 'root'
})
export class AppContextService {
  get data() { return AppContext; }

  private dataSubject = new BehaviorSubject(this.data);
  dataChange = this.dataSubject.asObservable();

  constructor(private routeService: RouteService) {}

  init() {
    this.routeService.primaryRoute$.pipe(take(1)).subscribe(route => {
      const prod = !environment.debug;
      const query = route?.snapshot.queryParams || {};

      if (!prod && '$ff' in query) {
        this.update({ fastForward: true });
        console.log('enabled fast-forward mode');
      }
    });
  }

  update(values: Partial<AppContext>) {
    for (const key in values) {
      const value = (values as any)[key];

      if (value !== undefined) {
        (AppContext as any)[key] = value;
      }
    }

    this.publish();
  }

  set(data: AppContext) {
    AppContext = data;
    this.publish();
  }

  private publish() {
    this.dataSubject.next(this.data);
  }
}
